import { clearLocalStorage, clearSessionStorage, getToken } from '@/services/session-data';
import { HOME_PATH } from '../home/routes';

//import FirstAccess from './screens/first-access.vue';
const FirstAccess = () => import('./screens/first-access.vue')

//import PreActivationLogin from './screens/pre-activation-login.vue';
const PreActivationLogin = () => import('./screens/pre-activation-login.vue')

//import ForgotPassword from './screens/forgot-password.vue';
const ForgotPassword = () => import('./screens/forgot-password.vue')

//import Login from './screens/login.vue';
const Login = () => import('./screens/login.vue')

const toDashboardIfLogged = (next) => {
  let newPath;
  const authUser = getToken();
  if (!!authUser) {
    newPath = { path: HOME_PATH };
  }
  next(newPath);
};

const loginRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      hideFromMenu: true,
    },
    beforeEnter: (to, from, next) => {
      toDashboardIfLogged(next);
    },
  },
  {
    path: '/recuperar-senha',
    name: 'Recuperar Senha',
    component: ForgotPassword,
    meta: {
      hideFromMenu: true,
    },
    beforeEnter: (to, from, next) => {
      clearLocalStorage();
      clearSessionStorage();
      next();
    },
  },
  {
    path: '/desbloquear',
    name: 'Desbloquear',
    component: ForgotPassword,
    meta: {
      hideFromMenu: true,
      title: "Ativação de usuário"
    },
    beforeEnter: (to, from, next) => {
      clearLocalStorage();
      clearSessionStorage();      
      next();
    },
  },
  {
    path: '/redefinicao-de-senha',
    name: 'Redefinição de senha',
    component: FirstAccess,
    meta: {
      hideFromMenu: true,
    },
    beforeEnter: (to, from, next) => {
      clearLocalStorage();
      clearSessionStorage();
      next();
    },
  },
  {
    path: '/usuario/pre-ativacao',
    name: 'Pre-Ativação de Cadastro do Usuário',
    component: PreActivationLogin,
    meta: {
      hideFromMenu: true,
    },
    beforeEnter: (to, from, next) => {
      clearLocalStorage();
      clearSessionStorage();
      next();
    },
  },
];

export { loginRoutes };

